/**
 * Environment Configuration
 * Centralized configuration for all environment variables used in the frontend
 * Provides validation and safe defaults for required and optional variables
 */

const required = [
  'VITE_FIREBASE_API_KEY',
  'VITE_FIREBASE_AUTH_DOMAIN',
  'VITE_FIREBASE_PROJECT_ID',
  'VITE_FIREBASE_STORAGE_BUCKET',
  'VITE_FIREBASE_APP_ID'
];

function getEnv() {
  const cfg = {
    // API base URL (defaults to /api for production same-origin requests)
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || '/api',

    // Socket.IO configuration
    socketUrl: import.meta.env.VITE_SOCKET_URL || window.location.origin,
    socketPath: import.meta.env.VITE_SOCKET_PATH || '/ws', // HTTP path where Socket.IO is served
    socketNamespace: import.meta.env.VITE_SOCKET_NAMESPACE || '/ws', // Socket.IO namespace

    // Public app URL for QR codes, redirects, etc.
    publicAppUrl: import.meta.env.VITE_PUBLIC_APP_URL || window.location.origin,

    // Firebase configuration (required)
    firebase: {
      apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
      authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
      projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
      storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
      appId: import.meta.env.VITE_FIREBASE_APP_ID,
      messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID
    }
  };

  // Validate required env vars in development
  if (import.meta.env.MODE !== 'production') {
    const missing = required.filter((k) => !import.meta.env[k]);
    if (missing.length) {
      // eslint-disable-next-line no-console
      console.warn('[ENV] Missing required env vars:', missing);
    }
  }

  return cfg;
}

// Export singleton instance
export default getEnv();
